// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AspectRatio_wrapper__0cRWj","aspect169":"AspectRatio_aspect169__gCwaU","aspect164":"AspectRatio_aspect164__62xNv"};